export default __webpack_public_path__ + "static/media/cardIcon.b956d79b.svg";